// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.adSliderImage {
    width: 100%;
    border-radius: 16px;
}

.sliderItem {
    height: 298px;;
    padding: 0 8px;
    overflow: hidden;
}

.sliderItemImage {
    width: 100%;
    height: 100%;
    object-fit: cover;
}

.sliderCounter {
    font-family: Alegreya Sans;
    font-size: 20px;
    font-weight: 700;
    line-height: 16px;
    text-align: left;
    color: #000000;
    background: #FFF4D9;
    padding: 6px 9px;
    width: max-content;
    border-radius: 50px;
    position: absolute;
    z-index: 1;
    right: 15px;
    top: 399px;
}`, "",{"version":3,"sources":["webpack://./src/components/Main/Ad/AdSlider/AdSlider.css"],"names":[],"mappings":"AAAA;IACI,WAAW;IACX,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,iBAAiB;AACrB;;AAEA;IACI,0BAA0B;IAC1B,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,gBAAgB;IAChB,cAAc;IACd,mBAAmB;IACnB,gBAAgB;IAChB,kBAAkB;IAClB,mBAAmB;IACnB,kBAAkB;IAClB,UAAU;IACV,WAAW;IACX,UAAU;AACd","sourcesContent":[".adSliderImage {\n    width: 100%;\n    border-radius: 16px;\n}\n\n.sliderItem {\n    height: 298px;;\n    padding: 0 8px;\n    overflow: hidden;\n}\n\n.sliderItemImage {\n    width: 100%;\n    height: 100%;\n    object-fit: cover;\n}\n\n.sliderCounter {\n    font-family: Alegreya Sans;\n    font-size: 20px;\n    font-weight: 700;\n    line-height: 16px;\n    text-align: left;\n    color: #000000;\n    background: #FFF4D9;\n    padding: 6px 9px;\n    width: max-content;\n    border-radius: 50px;\n    position: absolute;\n    z-index: 1;\n    right: 15px;\n    top: 399px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
